/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartPriceTable_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartItemPricing_user$ref: FragmentReference;
export type CartItemPricing_user = {|
  +$fragmentRefs: CartPriceTable_user$ref,
  +$refType: CartItemPricing_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartItemPricing_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartPriceTable_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '939e259b93e930bc69c22e2e4c0de910';
module.exports = node;
